import Immutable from 'immutable';

import app from './AppReducer';
import analytics from './AnalyticsReducer';
import auth from './AuthReducer';
import availabilityDetail from './AvailabilityDetailReducer';
import drawer from './DrawerReducer';
import internalError from './InternalErrorReducer';
import library from './LibraryReducer';
import localization from './LocalizationReducer';
import optIn from './OptInReducer';
import recommendation from './RecommendationReducer';
import search from './search';
import shelves from './shelves';
import ugc from './ugc';
import templates from './TemplatesReducer';
import user from './UserReducer';
import borrowing from './borrowing';

import ui from './ui';
import entities from './entities';

export default Immutable.Map({
  app,
  availabilityDetail,
  auth,
  analytics,
  drawer,
  library,
  localization,
  recommendation,
  entities,
  templates,
  search,
  shelves,
  optIn,
  internalError,
  ui,
  user,
  borrowing,
  ugc
});



// WEBPACK FOOTER //
// ./app/reducers/index.js